<!-- <form [formGroup]="clientForm" (ngSubmit)="onSubmit()"> -->
<div class="searchbar-whereapp">
  <!-- <div id="salva-modifiche-div">
                <button id="salva-modifiche-button" type="submit" [disabled]="!clientForm.valid">
                    <mat-icon aria-hidden="false" id="salva-modifiche-icon">save</mat-icon>
                    <span id="salva-modifiche-text">Salva modifiche</span>
                </button>
            </div> -->
  <button
    mat-flat-button
    id="back-toolbar-button"
    (click)="onBackButtonClick()"
  >
    <mat-icon [inline]="true">chevron_left</mat-icon>
    Indietro
  </button>
</div>

<mat-progress-bar
  mode="indeterminate"
  style="position: absolute; top: 68px; z-index: 27"
  [hidden]="!this.loading"
>
</mat-progress-bar>

<div id="main-container">
  <mat-horizontal-stepper [linear]="true" #stepper style="height: 100%">
    <mat-step [stepControl]="translatesFormGroup">
      <form [formGroup]="translatesFormGroup">
        <ng-template matStepLabel>Dettagli</ng-template>
        <!--  SE E'2 VIENE VISUALIZZATA PERCHE' SONO NEI SERVIZI GEOLOCALIZZATI -->
        <div *ngIf="this.lateServicesType == 2">
          <mat-form-field appearance="fill" id="url-field" class="mt-1">
            <mat-label>Url*</mat-label>
            <input matInput type="text" formControlName="url" />
          </mat-form-field>
        </div>
        <mat-accordion formArrayName="translates">
          <!-- <h3>Translates</h3> -->
          <mat-expansion-panel
            *ngFor="let translate of translates.controls; let i = index"
            class="custom-expansion-panel mat-elevation-z6"
            [formGroup]="translate"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span>{{ TRANSLATES_META[i].languageLabel }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-form-field appearance="fill">
              <mat-label>Titolo*</mat-label>
              <input matInput type="text" formControlName="subject" />
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Descrizione*</mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="4"
                cdkAutosizeMaxRows="4"
                formControlName="content"
              ></textarea>
            </mat-form-field>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="actions-container">
          <button mat-stroked-button matStepperPrevious>Indietro</button>
          <button mat-stroked-button matStepperNext>Avanti</button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="logoFormGroup">
      <form [formGroup]="logoFormGroup" id="logoForm">
        <ng-template matStepLabel>Logo</ng-template>
        <div *ngIf="logoBase64" id="image-container">
          <img
            src="{{ logoBase64 }}"
            width="100%"
            height="100%"
            style="border-radius: 50%"
            id="logo-img"
          />
          <!-- {{ logoForm.value.logo?.files[0] | json }} -->
        </div>
        <div id="image-field">
          <mat-form-field appearance="outline">
            <mat-label>Logo</mat-label>
            <ngx-mat-file-input
              placeholder="Logo"
              accept="image/*"
              (change)="handleFileInput($event.target.files[0])"
            >
            </ngx-mat-file-input>
            <mat-icon matSuffix>folder</mat-icon>
          </mat-form-field>
        </div>
      </form>
      <div class="actions-container">
        <button mat-stroked-button matStepperPrevious>Indietro</button>
        <button mat-stroked-button matStepperNext>Avanti</button>
      </div>
    </mat-step>
    <mat-step [stepControl]="areaFormGroup">
      <form [formGroup]="areaFormGroup">
        <ng-template matStepLabel>Area</ng-template>
        <app-area-factory
          (areeChanged)="onAreaChanged($event)"
        ></app-area-factory>
        <div class="actions-container">
          <button mat-stroked-button matStepperPrevious>Indietro</button>
          <button mat-stroked-button matStepperNext>Avanti</button>
        </div>
      </form>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Fatto</ng-template>
      <p>Servizio pronto alla generazione.</p>
      <div class="actions-container">
        <button mat-stroked-button matStepperPrevious>Indietro</button>
        <button mat-stroked-button (click)="onServiceSave()">Salva</button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>

<div class="loading" *ngIf="sub === true"></div>
